import { makeStyles } from '@material-ui/core';
import Colors from '../Colors';

export const useStyles = makeStyles({
  table: {
    width: '100%',
    border: '1px solid black',
  },
  tableHead: {
    backgroundColor: Colors.main,
    color: '#404040',
  },
  tableCellHead: {
    color: 'white',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  tableTh: {
    backgroundColor: '#9E9C99',
    color: 'white',
    fontSize: '14px',
  },
  tableCell: {
    border: '1px solid black',
    fontSize: '16px',

  },
});
